<template>
  <div v-if="loading">
    <div class="row">
      <div class="col-12">
        <label class="font28 font500">
          <i class="fas fa-history fa-13"></i> ประวัติการส่งข้อความ
        </label>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-12">
        <!-- <div class="d-flex flex-row mr-5"> -->
        <div class="row">
          <div class="align-self-center ml-3">วัน / เวลา ที่ส่ง</div>
          <div class="align-self-center col-12 col-md-3">
            <date-picker
              class="input-date"
              valuetype="format"
              type="datetime"
              lang="en"
              v-model="search.date_send"
            ></date-picker>
          </div>
          <div class="align-self-center ml-3">วัน / เวลา ที่ตั้งส่ง</div>
          <div class="col-12 col-md-3">
            <date-picker
              class="input-date"
              valuetype="format"
              type="datetime"
              lang="en"
              v-model="search.date_set"
            ></date-picker>
          </div>
        </div>
        <div class="row">
          <div class="align-self-center ml-3">สถานะข้อความ</div>
          <div class="col-12 col-md-3 px-2 pt-2">
            <select
              class="browser-default custom-select"
              v-model="search.status"
            >
              <option disabled value="null">ทั้งหมด</option>
              <option value="1">ส่งเรียบร้อย</option>
              <option value="2">ยังไม่ได้ส่ง</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="align-self-center ml-3">เลือกการค้นหา</div>
          <div class="col-12 col-md-3 p-2">
            <select class="browser-default custom-select" v-model="search.type">
              <option disabled value="null">ทั้งหมด</option>
              <option value="1">วันที่ตั้งส่ง</option>
              <option value="2">วันที่ส่ง</option>
              <option value="3">ข้อความ</option>
              <option value="4">ผู้ส่ง</option>
              <option value="5">จำนวนเบอร์</option>
              <option value="6">เครดิตที่ใช้</option>
            </select>
          </div>

          <div class="col-12 col-md-3 p-2">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon">
                  <mdb-icon far icon="edit" />
                </span>
              </div>
              <input
                type="text"
                class="form-control"
                v-model="search.text"
                aria-describedby="basic-addon"
                width="100%"
              />
            </div>
          </div>
          <div class="col-12 col-md-4 py-1">
            <button
              type="button"
              class="btn btn-search color_white font12"
              style="font-weight:400; margin-left:-8px"
              @click="Searchfilter()"
            >
              <i class="fab fa-sistrix"></i> Search
            </button>
            <download-excel
              class="btn btn-exel color_white font12"
              :data="json_data"
              :fields="json_fields"
              worksheet="My Worksheet"
              name="ประวัติการส่งข้อความ.xls"
              style="font-weight:400;"
              >Excel</download-excel
            >
            <button
              type="button"
              class="btn btn-cancel color_white font12"
              style="font-weight:400;"
              @click="Cancelfilter()"
            >
              <i class="fas fa-times"></i> Cancel
            </button>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 p-2">
            <span class="align-self-center font14 mr-2"
              >*สัญลักษณ์การแสดงข้อมูล</span
            >
            <label class="bg-file-search text-white font14 m-0">
              <mdb-icon far icon="file-alt" />
            </label>
            = กดเพื่อดูรายการการส่งข้อความ
            <label class="btn-status-green text-white text-center ml-2 mb-2"
              >สำเร็จ</label
            >
            <label class="btn-status-red text-white text-center ml-1"
              >ไม่สำเร็จ</label
            >
            <label class="btn-status-yellow text-white text-center ml-1"
              >กำลังรอ</label
            >
          </div>
        </div>

        <div>
          <mdb-datatable
            :arrows="true"
            :data="data"
            striped
            bordered
            :searching="false"
            scrollY
            maxHeight="680px"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import $ from "jquery";
let no = 0;
export default {
  name: "Messagereport",
  components: {
    DatePicker,
  },
  data() {
    return {
      dateselect: new Date(),
      loading: false,
      search: {
        status: null,
        date_send: null,
        date_set: null,
        type: null,
        text: null,
      },
      json_fields: {
        date_set: "date_set",
        date_send: "date_send",
        message: "message",
        sender: "sender",
        amount_phone: "amount_phone",
        send: "send",
        dr: "dr",
        username: "username",
        Management: "Management",
      },
      json_data: [],
      data: {
        columns: [
          {
            label: "#",
            field: "id2",
            sort: true,
            format: (value) => {
              no = value - 1;
              return value;
            },
          },
          {
            label: "รายละเอียด",
            field: "refer",
            sort: true,
            format: (value) => {
              var dateuse = moment(this.data.rows[no].date_send).format(
                "YYYYMMDD"
              );
              var datenow = moment().format("YYYYMMDD");
              if (dateuse >= datenow || this.data.rows[no].status == 2) {
                return (
                  '<a class="clikrouter" datenow="' +
                  value +
                  '"><div class="text-center"><label class="bg-file-search text-white font14" style="cursor: pointer;"><mdb-icon far icon="file-alt" />' +
                  (value[0]
                    ? '<i class="fas fa-file-alt fa-13"></i>'
                    : '<i class="fas fa-file-alt fa-13"></i>') +
                  "</label></div></a>"
                );
                //return ('<a class="btn btn-success clikrouter" datenow="'+value+'">asd</a>')
              } else {
                return (
                  '<a class="clikrouter" date2="' +
                  moment(dateuse).format("YYYY-MM-DD") +
                  '" datenow="' +
                  value +
                  '" ' +
                  '><div class="text-center"><label class="bg-file-search text-white font14" style="cursor: pointer;"><mdb-icon far icon="file-alt" />' +
                  (value[0]
                    ? '<i class="fas fa-file-alt fa-13"></i>'
                    : '<i class="fas fa-file-alt fa-13"></i>') +
                  "</label></div></a>"
                );
              }
            },
          },
          {
            label: "วันที่ตั้งส่ง",
            field: "date_send",
            sort: true,
            format: (value) => {
              if (value) {
                return moment(value).format("DD/MM/YYYY HH:mm:ss");
              }
            },
          },
          {
            label: "วันที่ส่ง",
            field: "date_set",
            sort: true,
            format: (value) => {
              if (value) {
                return moment(value).format("DD/MM/YYYY HH:mm:ss");
              }
            },
          },
          {
            label: "ข้อความ",
            field: "message",
            sort: true,
            format: (value) => {
              if (value) {
                return (
                  '<label class="norwarp" title="' +
                  value +
                  '" >' +
                  value +
                  "</label>"
                );
              }
            },
          },
          {
            label: "ผู้ส่ง",
            field: "sender",
            sort: true,
          },
          {
            label: "จำนวนเบอร์",
            field: "amount_phone",
            sort: true,
          },
          {
            label: "เครดิตที่ใช้",
            field: "use_credit",
            sort: true,
          },
          {
            label: "สถานะ",
            field: "send",
            sort: true,
            format: (value) => {
              let data = "";
              data =
                "<span class='btn-status-green text-white font13 px-3'>" +
                (value[0] ? value[0] : 0) +
                "</span>";
              data +=
                "<span class='btn-status-red text-white font13 px-3'>" +
                (value[1] ? value[1] : 0) +
                "</span>";
              return data;
            },
          },
          {
            label: "DR Status",
            field: "dr",
            sort: true,
            format: (value) => {
              let data = "";
              data =
                "<span class='btn-status-green text-white font13 px-3' >" +
                (value[0] ? value[0] : 0) +
                "</span>";
              data +=
                "<span class='btn-status-red text-white font13 px-3'>" +
                (value[1] ? value[1] : 0) +
                "</span>";
              data +=
                "<span class='btn-status-yellow text-white font13 px-3'>" +
                (value[2] ? value[2] : 0) +
                "</span>";
              return data;
            },
          },
          // {
          // 	label: 'User',
          // 	field: 'username',
          // 	sort: true,
          // },
        ],
        rows: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      isLogin: "isLogin",
      user: "user",
      token: "token",
    }),
  },
  methods: {
    clickCallback: function(pageNum) {
      console.log(pageNum);
    },
    ...mapActions({
      storeLogin: "login",
      storeLoout: "logout",
      callApiMotherFucker: "callApiMotherFucker",
    }),
    onclickRoute() {
      let context = this;
      $(".clikrouter").on("click", function() {
        let id = $(this).attr("datenow") || "";
        let date2 = $(this).attr("date2") || "";
        if (date2 == "") {
          context.$router.push("/Takeoutreport?see=" + id);
        } else {
          context.$router.push("/Takeoutreport?see=" + id + "&date=" + date2);
        }
        //edit_detial.idedituser = id; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
      });
    },
    async Searchfilter() {
      this.loading = false;
      //console.log(this.search);
      this.search.date_send =
        this.search.date_send != null
          ? moment(this.search.date_send).format("YYYY-MM-DD ")
          : null;
      this.search.date_set =
        this.search.date_set != null
          ? moment(this.search.date_set).format("YYYY-MM-DD ")
          : null;
      await this.callApiMotherFucker({
        method: "POST",
        path: "/message/query",
        data: this.search,
      }).then((res) => {
        this.loading = true;
        if (res.payload.length > 0) {
          this.data.rows = this.$add_index(res.payload);
          this.data.rows.forEach((value, index) => {
            this.data.rows[index].send = [
              value.send_success,
              value.send_unsuccess,
            ];
            this.data.rows[index].dr = [
              value.dr_success,
              value.dr__unsuccess,
              value.dr_wait,
            ]; // value ใน array จะเรียงตามตำแหน่ง 0,1,2,+++
          });
        } else {
          this.data.rows = [];
          setTimeout(() => {
            this.loading = true;
          }, 50);
        }
      });
      this.search = {
        status: null,
        date_send: null,
        date_set: null,
        type: null,
        text: null,
      };
      this.onclickRoute();
    },
    async Cancelfilter() {
      this.search = {
        status: null,
        date_send: null,
        date_set: null,
        type: null,
        text: null,
      };
      this.Searchfilter();
    },
  },
  async mounted() {
    //  let edit_detial = this;
    // $(".btnbtn").on("click", function() {
    //   let id = $(this).attr("dataid") || 0;
    //   console.log("test btn");
    //   edit_detial.idedituser = id; // เอาid มาเก็บไว้ในตัวแปร idedituser เพื่อจะนำไปอัพเดท
    // });

    this.dateselect = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    await this.callApiMotherFucker({
      method: "POST",
      path: "/message/All",
      data: {},
    }).then((res) => {
      if (res.payload) {
        this.loading = true;
        this.data.rows = this.$add_index(res.payload);
        this.data.rows.forEach((value, index) => {
          // value คือ ค่าใน index , index คือ ค่าใน payload
          this.data.rows[index].send = [
            value.send_success,
            value.send_unsuccess,
          ];
          this.data.rows[index].dr = [
            value.dr_success,
            value.dr__unsuccess,
            value.dr_wait,
          ]; // value ใน array จะเรียงตามตำแหน่ง 0,1,2,+++
          this.json_data.push({
            date_set: this.data.rows[index].date_set,
            date_send: this.data.rows[index].date_send,
            message: this.data.rows[index].message,
            sender: this.data.rows[index].sender,
            amount_phone: this.data.rows[index].amount_phone,
            send: this.data.rows[index].send,
            dr: this.data.rows[index].dr,
            username: this.data.rows[index].username,
            Management: this.data.rows[index].Management,
          });
        });
      }
    });
    this.onclickRoute();
  },
};
</script>

<style>
.bg-file-search {
  /* display: inline-table; */
  background: #2f80ed;
  padding: 1px 7px 0px 7px;
  border-radius: 3px;
}
</style>
